import { DISABLED_MODULE } from "../../../global";
import { fetchQuery } from "../../../utils/commonComponent/fetched";
import { editAccessOptions, moduleList } from "../../constants/userConstant";

export const fetchRBACData = async (store, setrollList) => {
  try {
    const rollLists = await fetchQuery(`select * from rbac where status = 1`);
    let res = rollLists || [];
    if (store) {
      sessionStorage.setItem("roleLists", JSON.stringify(res));
    } else {
      setrollList(res);
    }
  } catch (error) {
    console.error("Error fetching RBAC data:", error);
  }
};

export function getPermissions(moduleId) {
  const ignoreKeys = new Set(["l1", "hod", "h1", "h2", "l2"]);

  // Helper: convert label to camelCase key
  const toKey = (label) => {
    const s = label.replace(/\s+/g, "");
    return s.charAt(0).toLowerCase() + s.slice(1);
  };

  // Helper: build permissions map from accessSet
  const buildPermissions = (accessSet) =>
    Object.fromEntries(
      editAccessOptions.map((option) => [
        toKey(option.label),
        accessSet.has(option.id.toString()),
      ])
    );

  // Helper: get relevant roles & build accessSet
  const getAccessSet = (roleLists, modulesFromStorage) => {
    const accessSet = new Set();
    roleLists
      .filter(
        (r) =>
          modulesFromStorage.includes(r.id.toString()) &&
          r.moduleId.split(",").includes(moduleId.toString())
      )
      .forEach((r) => r.access.split(",").forEach((a) => accessSet.add(a)));
    return accessSet;
  };

  try {
    const roleLists = JSON.parse(sessionStorage.getItem("roleLists") || "[]");
    const modulesFromStorage = (localStorage.getItem("modules") || "")
      .split(",")
      .map((m) => m.trim());
    const userType = localStorage.getItem("type");

    const accessSet = getAccessSet(roleLists, modulesFromStorage);
    const permissions = buildPermissions(accessSet);

    // Super Admin (type 1) → all true, except ignoreKeys only if true in permissions
    if (userType == 1) {
      return Object.fromEntries(
        Object.entries(permissions).map(([key, val]) => [
          key,
          !ignoreKeys.has(key) || val === true,
        ])
      );
    }

    return permissions;
  } catch (e) {
    console.error("Error parsing roleLists:", e);

    // Default → everything false
    return Object.fromEntries(
      editAccessOptions.map((option) => [toKey(option.label), false])
    );
  }
}


// RBAC Sidebar Module Access Helper
export function hasAccessToModule(moduleAccessId) {
  try {
    // Check if this module is disabled
    const moduleLabel = moduleList.find(m => m.id == moduleAccessId)?.label;
    if (moduleLabel && DISABLED_MODULE.includes(moduleLabel)) return false;

    const userType = localStorage.getItem("type");
    if (userType === "1") return true; // Admin → full access

    const modulesFromStorage = (localStorage.getItem("modules") || "")
      .split(",").map((m) => m.trim()); // role IDs user has

    const roleLists = JSON.parse(sessionStorage.getItem("roleLists") || "[]");
    // Match roles by role ID
    const relevantRoles = roleLists.filter((r) =>
      modulesFromStorage.includes(r.id.toString())
    );
    // Check if any matched role contains this moduleAccessId
    return relevantRoles.some((r) =>
      r.moduleId.split(",").includes(moduleAccessId.toString())
    );
  } catch (e) {
    console.error("Error in hasAccessToModule:", e);
    return false;
  }
}


export const getEmployeeData = async (employeeID) => {
  try {
    const [data] = await fetchQuery(`SELECT * FROM employeeOtherData WHERE employeeId = ${employeeID}`);
    data && localStorage.setItem("designation", data.hrDesignation);
  } catch (error) {
    console.error("Error fetching employee data:", error);
  }
};

export const getEmployee = async (employeeID) => {
  try {
    const [data] = await fetchQuery(`SELECT * FROM employees WHERE id = ${employeeID}`);
    data && localStorage.setItem("employeesName", data.name);
  } catch (error) {
    console.error("Error fetching employee data:", error);
  }
};
